import { PersistenceStateUsingContext } from "@/shared/persistence-state/persistence-state-info";
import {
  ArtefactPage,
  ArtefactPageActions,
  ArtefactPageContent,
  ArtefactPageHeader,
  ArtefactPageNavigation,
  ArtefactPageNavigationLink,
  ArtefactPageNavigationOutlet,
} from "@/shared/service-manager/default-ui/artefact-page/artefact-page";
import { useParams } from "react-router";
import { useGetInspectionRulesQuery } from "@/services/backend/rules/service";
import CreateDifferentiationModal from "./_components/create-differentiation-modal";
import CreateInspectionModal from "./_components/create-inspection-modal";
import { useShowCountingQuery } from "@/services/backend/countings/service";
import { ArtefactNotReadyAlert } from "@/shared/service-manager/artefact/artefact-sheet";
import { useErrArtefactNotReady } from "@/shared/service-manager/artefact/err-artefact-not-ready";

export function CountingRoute() {
  const { processId, customerId, countingId } = useParams();
  const { data: rule } = useGetInspectionRulesQuery({ processId: processId! });
  const { data: counting } = useShowCountingQuery({ id: countingId! });
  const immutable = !!counting?.counting.immutable;
  const { notReadyError } = useErrArtefactNotReady();

  if (!rule) {
    return null;
  }

  const links = [
    {
      to: "first-counting",
      label: "1. Zählung",
    },
    {
      to: "second-counting",
      label: "2. Zählung",
    },
    {
      to: "sample-overview",
      label: "Proben",
    },
  ];

  return (
    <ArtefactPage>
      <ArtefactPageHeader>
        <ArtefactPageNavigation>
          {links.map((link) => (
            <ArtefactPageNavigationLink to={link.to} key={link.to}>
              {link.label}
            </ArtefactPageNavigationLink>
          ))}
        </ArtefactPageNavigation>
        <ArtefactPageActions>
          <PersistenceStateUsingContext className="mr-2" />
          {!immutable && rule.hasDifferentiation && (
            <CreateDifferentiationModal
              processId={processId!}
              customerId={customerId!}
              countingId={countingId!}
            />
          )}
          {!immutable && !rule.hasDifferentiation && (
            <CreateInspectionModal
              processId={processId!}
              countingId={countingId!}
            />
          )}
        </ArtefactPageActions>
      </ArtefactPageHeader>
      <ArtefactPageContent>
        <ArtefactNotReadyAlert error={notReadyError} artefact="Zählung" />
        <ArtefactPageNavigationOutlet />
      </ArtefactPageContent>
    </ArtefactPage>
  );
}
